import React from "react";
import {templateNameId, templateNameType} from "./templateData";
import {TemplateNoteRead} from "./templateRead/TemplateNoteRead";
import {TemplateOxigenRead} from "./templateRead/TemplateOxigenRead";
import {TemplateVentilotherapyRead} from "./templateRead/TemplateVentilotherapyRead";
import {TemplateSleepRead} from "./templateRead/TemplateSleepRead";
import {TemplateConcentratorRead} from "./templateRead/TemplateConcentratorRead";
import {TemplateSleepStudyRead} from "./templateRead/TemplateSleepStudyRead";
import {TemplateScoredDiagnosticStudyRead} from "./templateRead/TemplateScoredDiagnosticStudyRead";
import {TemplateTherapyPLRead, TemplateTherapyRead} from "./templateRead/TemplateTherapyRead";
import {TemplateTitrationPLRead, TemplateTitrationRead} from "./templateRead/TemplateTitrationRead";
import {TemplateMaskProductPLRead, TemplateMaskProductRead} from "./templateRead/TemplateMaskProductRead";
import {TemplateGenericProductPLRead, TemplateGenericProductRead} from "./templateRead/TemplateGenericProductRead";
import {TemplateTherapyNivPLRead, TemplateTherapyNivRead} from "./templateRead/TemplateTherapyNivRead";
import {TemplateReadPrescription} from "./templateRead/lox_poc_toc_cox/TemplateReadPrescription";

export function TemplateSelectProductRead({template, data, documents}) {
    const templateList = {
        [templateNameId[templateNameType.note]]: <TemplateNoteRead data={data}/>,
        [templateNameId[templateNameType.ossigeno]]: <TemplateOxigenRead data={data}/>,
        [templateNameId[templateNameType.ventiloterapia]]: <TemplateVentilotherapyRead data={data}/>,
        [templateNameId[templateNameType.sleep]]: <TemplateSleepRead data={data}/>,
        [templateNameId[templateNameType.concentrator]]: <TemplateConcentratorRead data={data}/>,
        [templateNameId[templateNameType.sleepStudy]]: <TemplateSleepStudyRead data={data}/>,
        [templateNameId[templateNameType.therapy]]: <TemplateTherapyRead data={data}/>,
        [templateNameId[templateNameType.scoredDiagnosticStudy]]: <TemplateScoredDiagnosticStudyRead data={data}
                                                                                                     documents={documents}/>,
        [templateNameId[templateNameType.titration]]: <TemplateTitrationRead data={data}/>,
        [templateNameId[templateNameType.maskProduct]]: <TemplateMaskProductRead data={data}/>,
        [templateNameId[templateNameType.genericProduct]]: <TemplateGenericProductRead data={data}/>,
        [templateNameId[templateNameType.nivTherapy]]: <TemplateTherapyNivRead data={data}/>,
        [templateNameId[templateNameType.therapyPL]]: <TemplateTherapyPLRead data={data}/>,
        [templateNameId[templateNameType.titrationPL]]: <TemplateTitrationPLRead data={data}/>,
        [templateNameId[templateNameType.maskProductPL]]: <TemplateMaskProductPLRead data={data}/>,
        [templateNameId[templateNameType.genericProductPL]]: <TemplateGenericProductPLRead data={data}/>,
        [templateNameId[templateNameType.nivTherapyPL]]: <TemplateTherapyNivPLRead data={data}/>,

        [templateNameId[templateNameType.COX]]: <TemplateReadPrescription data={data} types={['COX']}/>,
        [templateNameId[templateNameType.COX_POC]]: <TemplateReadPrescription data={data} types={['COX, POC']}/>,
        [templateNameId[templateNameType.COX_TOC]]: <TemplateReadPrescription data={data} types={['COX, TOC']}/>,
        [templateNameId[templateNameType.LOX]]: <TemplateReadPrescription data={data} types={['LOX']}/>,
        [templateNameId[templateNameType.LOX_POC]]: <TemplateReadPrescription data={data} types={['LOX, POC']}/>,
        [templateNameId[templateNameType.LOX_TOC]]: <TemplateReadPrescription data={data} types={['LOX', 'TOC']}/>,
        [templateNameId[templateNameType.POC]]: <TemplateReadPrescription data={data} types={['POC']}/>,
        [templateNameId[templateNameType.TOC]]: <TemplateReadPrescription data={data} types={['TOC']}/>,

    };
    return (
        <>
            {templateList[template]}
        </>
    );
}
